import { render, staticRenderFns } from "./AlipayRecharge.vue?vue&type=template&id=3284e516&scoped=true&"
import script from "./AlipayRecharge.vue?vue&type=script&lang=js&"
export * from "./AlipayRecharge.vue?vue&type=script&lang=js&"
import style0 from "./AlipayRecharge.vue?vue&type=style&index=0&id=3284e516&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3284e516",
  null
  
)

export default component.exports